export const wmdaCodeMap = {
    '/auth/apply': { eventId: 149, eventName: 's_daikuan_self_58shd_index_2019' },

    // 短链接推广页面
    '/spread': { eventId: 273, eventName: '推广页面曝光量' },
    // 新短链推广页面
    '/newSpread': { eventId: 302, eventName: '新推广页面曝光量' },

    // 二期埋点
    '/repayV2/borrow/record': { eventId: 333, eventName: '借款记录页面曝光量' }, // 借款记录
    '/repayV2/borrow/detail': { eventId: 336, eventName: '借款详情页面曝光量' },  // 借款详情
    '/repayV2/result': { eventId: 349, eventName: '展现_还款_还款详情_还款结果' },
    '/repayV2/bank/card/list': { eventId: 428, eventName: '展现_我的银行卡' }, // 绑卡列表
    '/repayV2/borrow/recordProof': { eventId: 498, eventName: '结清证明-展现' }, // 结清证明页面


    // 二期授信
    '/accredit/auth': { eventId:995, eventName:'展现-授信-验二页面' },
    '/accredit/agreement/auth': { eventId: 373, eventName: '展现_授信_人行协议页面' }, // 征信授权页
    '/accredit/auditingV2': { eventId: 375, eventName: '展现_授信_审核中页面' }, // 审核中页面

    // 二期用信
    '/verifyV2/base/info': { eventId: 416, eventName: '展现_用信_增验_基本信息' },
    '/verifyV2/emergency/contact': { eventId: 418, eventName: '展现_用信_增验_紧急联系人' },
    // '/withdrawV2/auditing': { eventId: 451, eventName: '展现_用信_审核中页面' },
    '/withdrawV2/audit/success': { eventId: 460, eventName: '展现_用信_借款成功' },
    '/withdrawV2/audit/failed': { eventId: 455, eventName: '展现_用信_审核失败' },
    '/withdraw/ocr/v2': { eventId: 444, eventName: '展现_用信_增验_ocr' },

    //提额流程
    '/amount/hall': { eventId: 1046, eventName: '展现_提额中心' },
    '/amount/history': { eventId:1056, eventName:'展现_提额历史'}
};
